import React from 'react';

const ImageModal = ({ image, onClose, onNext, onPrev }) => {
  if (!image) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="relative bg-white rounded-lg max-w-3xl max-h-full overflow-hidden">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-white bg-gray-800 rounded-full p-2 z-10"
        >
          &times;
        </button>
        <img src={image} alt="Expanded view" className="max-w-full max-h-full object-contain" />
        <button
          onClick={onPrev}
          className="absolute left-2 top-1/2 transform -translate-y-1/2 text-white bg-gray-800 rounded-full p-2 z-10"
        >
          {'<'}
        </button>
        <button
          onClick={onNext}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white bg-gray-800 rounded-full p-2 z-10"
        >
          {'>'}
        </button>
      </div>
    </div>
  );
};

export default ImageModal;
